var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMapPin = function SvgIconMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.187 9.984a1.802 1.802 0 0 1-1.796-1.797c0-.988.808-1.796 1.796-1.796.989 0 1.797.808 1.797 1.796 0 .989-.808 1.797-1.797 1.797zm5.391-1.617c0-3.261-2.38-5.57-5.39-5.57s-5.391 2.309-5.391 5.57c0 2.103 1.752 4.888 5.39 8.212 3.64-3.324 5.391-6.11 5.391-8.212zM10.188 1c3.773 0 7.187 2.893 7.187 7.367 0 2.983-2.399 6.514-7.188 10.602C5.4 14.88 3 11.35 3 8.367 3 3.893 6.414 1 10.187 1z",
    fillRule: "evenodd"
  })));
};

export default SvgIconMapPin;